import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box, 
  Avatar, 
  Chip, 
  Divider,
  Paper
} from '@mui/material';
import { User } from '../../types';

interface UserDetailsModalProps {
  user: User | null;
  open: boolean;
  onClose: () => void;
}

const UserDetailsModal: React.FC<UserDetailsModalProps> = ({ user, open, onClose }) => {
  if (!user) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        User Details
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Avatar 
            sx={{ 
              width: 80, 
              height: 80, 
              fontSize: 36, 
              bgcolor: 'primary.main',
              mb: 2
            }}
          >
            {user.name.charAt(0)}
          </Avatar>
          <Typography variant="h5" gutterBottom>
            {user.name}
          </Typography>
          <Chip 
            label={user.role === 'admin' ? 'Administrator' : 'Regular User'} 
            color={user.role === 'admin' ? 'secondary' : 'primary'}
            sx={{ mb: 2 }}
          />
        </Box>
        
        <Divider sx={{ mb: 3 }} />
        
        <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ width: { xs: '100%', sm: '30%' } }}>
              <Typography variant="body2" color="text.secondary">
                User ID
              </Typography>
              <Typography variant="body1">
                {user.id}
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '65%' } }}>
              <Typography variant="body2" color="text.secondary">
                Email Address
              </Typography>
              <Typography variant="body1">
                {user.email}
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '47%' } }}>
              <Typography variant="body2" color="text.secondary">
                Department
              </Typography>
              <Typography variant="body1">
                {user.department || 'Not specified'}
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '47%' } }}>
              <Typography variant="body2" color="text.secondary">
                Account Created
              </Typography>
              <Typography variant="body1">
                {new Date(user.createdAt).toLocaleDateString()}
              </Typography>
            </Box>
          </Box>
        </Paper>
        
        <Typography variant="body2" color="text.secondary">
          As a {user.role === 'admin' ? 'system administrator' : 'regular user'}, you can {user.role === 'admin' ? 'manage all resources, reservations, and users in the system' : 'create and manage your own reservations and join waitlists'}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDetailsModal;
